// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_nomad_fix__-T71V {
  background-color: red;
  font-weight: 700;
  padding: 4px;
  text-align: center;
}

.Header_nomad_logo__pB3N6 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
}
.Header_nomad_logo__pB3N6 img {
  max-height: 100%;
  width: 120px;
}

.Header_nomad_container__Y9NNV {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding-bottom: 12px;
  position: relative;
}
.Header_nomad_container__Y9NNV .Header_nomad_content__njnpx {
  display: flex;
  justify-content: space-between;
  width: 85%;
  margin: 0 auto;
}
.Header_nomad_container__Y9NNV .Header_nomad_left__WADgW {
  align-items: center;
  display: flex;
  gap: 40px;
}
.Header_nomad_container__Y9NNV .Header_nomad_left__WADgW .Header_nomad_pmPass__hRltL {
  display: none;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
}
.Header_nomad_container__Y9NNV .Header_nomad_left__WADgW .Header_nomad_nav__4irlq {
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 24px;
}
.Header_nomad_container__Y9NNV .Header_nomad_left__WADgW .Header_nomad_nav__4irlq .Header_nomad_selected__xv2kP {
  color: #eaae16;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz {
  display: flex;
  gap: 32px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_lang__rs8fq {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  gap: 4px;
  display: flex;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_lang__rs8fq .Header_nomad_langItem__HImH1 {
  cursor: pointer;
  transition: all 0.2s linear;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_yellow__Wgh8\\+ {
  color: #eaae16;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_loginBtn__wItrZ {
  display: block;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_login__p1OP1 {
  display: none;
  align-items: center;
  gap: 6px;
  color: #C2BDB2;
  font-size: 16px;
  font-weight: 600;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_btn__q3FwJ {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px;
  cursor: pointer;
  padding: 10px 22px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_btns__oh8N3 {
  align-items: center;
  display: flex;
  gap: 24px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #C2BDB2;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  gap: 20px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_points_row__8BzbQ {
  display: flex;
  gap: 5px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_points__btrYq {
  align-items: center;
  display: flex;
  gap: 4px;
  color: #a8b3d1;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_pointsValue__HseJg {
  font-size: 16px;
  font-weight: 600;
  color: #FAF9F8;
  text-align: center;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_line__K7rKc {
  background-color: rgba(255, 255, 255, 0.1490196078);
  height: 32px;
  width: 1px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_profile__zFESE {
  align-items: center;
  color: #a8b3d1;
  display: flex;
  gap: 8px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_profile__zFESE path {
  fill: #a8b3d1;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_profile__zFESE .Header_nomad_profileImg__i6kIu {
  width: 48px;
}
.Header_nomad_container__Y9NNV .Header_nomad_right__zdsVz .Header_nomad_enter__hZts7 {
  background-color: #333217;
  color: #EAD40C;
}
.Header_nomad_container__Y9NNV .Header_nomad_hoverY__A2FzT {
  font-family: "Open Sans SemiBold";
  font-size: 20px;
  letter-spacing: -0.02em;
  color: #B5C0DF;
  transition: all 0.2s linear;
}
.Header_nomad_container__Y9NNV .Header_nomad_hoverY__A2FzT:hover {
  color: #eaae16;
}
.Header_nomad_container__Y9NNV .Header_nomad_hoverY__A2FzT.Header_nomad_active__uIYnP {
  color: #eaae16;
}

@media (max-width: 1100px) {
  .Header_nomad_container__Y9NNV .Header_nomad_content__njnpx .Header_nomad_left__WADgW .Header_nomad_pmPass__hRltL {
    display: block;
  }
  .Header_nomad_container__Y9NNV .Header_nomad_content__njnpx .Header_nomad_left__WADgW .Header_nomad_nav__4irlq {
    display: none;
  }
  .Header_nomad_container__Y9NNV .Header_nomad_content__njnpx .Header_nomad_right__zdsVz .Header_nomad_login__p1OP1 {
    display: flex;
    color: #a8b3d1;
  }
  .Header_nomad_container__Y9NNV .Header_nomad_content__njnpx .Header_nomad_right__zdsVz .Header_nomad_login__p1OP1 path {
    fill: #a8b3d1;
  }
  .Header_nomad_container__Y9NNV .Header_nomad_content__njnpx .Header_nomad_right__zdsVz .Header_nomad_loginBtn__wItrZ {
    display: none;
  }
  .Header_nomad_container__Y9NNV .Header_nomad_content__njnpx .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_line__K7rKc,
  .Header_nomad_container__Y9NNV .Header_nomad_content__njnpx .Header_nomad_right__zdsVz .Header_nomad_auth__gPdfU .Header_nomad_profile__zFESE {
    display: none;
  }
}
.Header_nomad_langDropdown__6AMDU {
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/header/Header.nomad.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.nomad.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADF;AAGE;EACE,gBAAA;EACA,YAAA;AADJ;;AAKA;ECgBE,eAAA;EACA,gBAAA;EACA,kBAAA;EDfA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,iBAAA;EACA,+CAAA;EACA,kDAAA;EACA,oBAAA;EACA,kBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,cAAA;AADJ;AAIE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAFJ;AAII;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFN;AAKI;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAHN;AAMM;EACE,cEHU;AFDlB;AASE;EACE,aAAA;EACA,SAAA;AAPJ;AASI;EC7BF,eAAA;EACA,gBAAA;EACA,kBAAA;ED8BI,mBAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AANN;AAQM;EACE,eAAA;EACA,2BAAA;AANR;AAUI;EACE,cE3BY;AFmBlB;AAWI;EACE,cAAA;AATN;AAYI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAVN;AAaI;ECtDF,eAAA;EACA,gBAAA;EACA,kBAAA;EDuDI,kBAAA;EACA,eAAA;EACA,kBAAA;AAVN;AAaI;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAXN;AAcI;EChFF,eAAA;EACA,gBAAA;EACA,kBAAA;EDiFI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAXN;AAaM;EACE,aAAA;EACA,QAAA;AAXR;AAcM;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,cE3DI;AF+CZ;AAeM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAbR;AAgBM;EACE,mDAAA;EACA,YAAA;EACA,UAAA;AAdR;AAiBM;EACE,mBAAA;EACA,cE7EI;EF8EJ,aAAA;EACA,QAAA;AAfR;AAiBQ;EACE,aElFE;AFmEZ;AAkBQ;EACE,WAAA;AAhBV;AAqBI;EACE,yBAAA;EACA,cAAA;AAnBN;AAuBE;EACE,iCAAA;EACA,eAAA;EACA,uBAAA;EACA,cEtGY;EFwGZ,2BAAA;AAtBJ;AAwBI;EACE,cE3HY;AFqGlB;AAyBI;EACE,cE/HY;AFwGlB;;AA4BA;EAKQ;IACE,cAAA;EA7BR;EAgCM;IACE,aAAA;EA9BR;EAmCM;IACE,aAAA;IACA,cEpIE;EFmGV;EAmCQ;IACE,aEvIA;EFsGV;EAqCM;IACE,aAAA;EAnCR;EAwCQ;;IAEE,aAAA;EAtCV;AACF;AA6CA;EACE,WAAA;AA3CF","sourcesContent":["@use 'assets/styles/global.nomad.scss' as *;\n\n.fix {\n  background-color: red;\n  font-weight: 700;\n  padding: 4px;\n  text-align: center;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70px;\n\n  img {\n    max-height: 100%;\n    width: 120px;\n  }\n}\n\n.container {\n  @include subtitle4m;\n\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.15);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  padding-bottom: 12px;\n  position: relative;\n\n  .content {\n    display: flex;\n    justify-content: space-between;\n    width: 85%;\n    margin: 0 auto;\n  }\n\n  .left {\n    align-items: center;\n    display: flex;\n    gap: 40px;\n\n    .pmPass {\n      display: none;\n      font-size: 20px;\n      font-weight: 600;\n      color: #ffffff;\n    }\n\n    .nav {\n      align-items: center;\n      color: #ffffff;\n      display: flex;\n      gap: 24px;\n\n\n      .selected {\n        color: $control-primary;\n      }\n    }\n  }\n\n  .right {\n    display: flex;\n    gap: 32px;\n\n    .lang {\n      @include subtitle5;\n\n      align-items: center;\n      color: #ffffff;\n      gap: 4px;\n      display: flex;\n\n      .langItem {\n        cursor: pointer;\n        transition: all .2s linear;\n      }\n    }\n\n    .yellow {\n      color: $control-primary;;\n    }\n\n    .loginBtn {\n      display: block;\n    }\n\n    .login {\n      display: none;\n      align-items: center;\n      gap: 6px;\n      color: #C2BDB2;\n      font-size: 16px;\n      font-weight: 600;\n    }\n\n    .btn {\n      @include subtitle6m;\n\n      border-radius: 8px;\n      cursor: pointer;\n      padding: 10px 22px;\n    }\n\n    .btns {\n      align-items: center;\n      display: flex;\n      gap: 24px;\n    }\n\n    .auth {\n      @include subtitle4m;\n\n      align-items: center;\n      color: #C2BDB2;\n      display: flex;\n      font-size: 14px;\n      font-weight: 600;\n      gap: 20px;\n\n      .points_row {\n        display: flex;\n        gap: 5px;\n      }\n\n      .points {\n        align-items: center;\n        display: flex;\n        gap: 4px;\n        color: $text-body;\n      }\n\n      .pointsValue {\n        font-size: 16px;\n        font-weight: 600;\n        color: #FAF9F8;\n        text-align: center;\n      }\n\n      .line {\n        background-color: #FFFFFF26;\n        height: 32px;\n        width: 1px;\n      }\n\n      .profile {\n        align-items: center;\n        color: $text-body;\n        display: flex;\n        gap: 8px;\n\n        path {\n          fill: $text-body;\n        }\n\n        .profileImg {\n          width: 48px;\n        }\n      }\n    }\n\n    .enter {\n      background-color: #333217;\n      color: #EAD40C;\n    }\n  }\n\n  .hoverY {\n    font-family: \"Open Sans SemiBold\";\n    font-size: 20px;\n    letter-spacing: -0.02em;\n    color: $text-subtitle;\n\n    transition: all .2s linear;\n\n    &:hover {\n      color: $control-primary;\n    }\n\n    &.active {\n      color: $control-primary;\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .container {\n\n    .content {\n      .left {\n        .pmPass {\n          display: block;\n        }\n\n        .nav {\n          display: none;\n        }\n      }\n\n      .right {\n        .login {\n          display: flex;\n          color: $text-body;\n\n          path {\n            fill: $text-body;\n          }\n        }\n\n        .loginBtn {\n          display: none;\n        }\n\n        .auth {\n\n          .line,\n          .profile {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n.langDropdown {\n  width: auto;\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #b6c0cf;\n$icon-secondary: #8997AC;\n$icon-chevron: #8195df;\n$icon-hover: #97ACFB;\n$icon-pressed: #6F80C1;\n$icon-white: #ffffff;\n$icon-notification: #D63854;\n$icon-warning: #E37B4C;\n$icon-deposit: #A4DF28;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #0e113a;\n$background-secondary: #12143D;\n$background-snackbar: #1E1E30;\n$background-input: #05051B;\n$background-modal-main: rgba(5, 5, 27, 0.7);\n$background-modal-secondary: rgba(18, 20, 61, 0.7);\n\n$control-primary: #eaae16;\n$control-hover: #ffd029;\n$control-pressed: #D39D14;\n$control-green: #78aa0f;\n$control-green-hover: #9EE509;\n$control-green-pressed: #60880C;\n$control-dark: #2e4b96;\n$control-dark-hover: #375ab4;\n$control-dark-pressed: #253C78;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n$control-disabled: #2C2C4A;\n\n$text-title: #f6f6fc;\n$text-subtitle: #B5C0DF;\n$text-body: #a8b3d1;\n$text-link: #ffd029;\n$text-error: #ff6964;\n$text-warning: #ec985b;\n$text-white: #FFFFFF;\n$text-dark: #292621;\n\n$calendar-default: rgba(18, 20, 61, 0.8);\n$calendar-active: #12143D;\n$calendar-white: #ffffff;\n$calendar-dark-yellow: #333217;\n$calendar-text-yellow: #EAAE16;\n$calendar-dark-green: #2E4105;\n$calendar-text-green: #78AA0F;\n$calendar-dark-purple: #3A2159;\n$calendar-text-purple: #8F6ED4;\n$calendar-dark-blue: #19334F;\n$calendar-text-blue: #1D92FF;\n\n$dota-tag: rgba(255, 51, 51, 0.2);\n$dota-logo: #FF3333;\n$cs-tag: rgba(226, 182, 3, 0.15);\n$lol-tag: rgba(199, 155, 59, 0.15);\n$lol-logo: rgba(199, 155, 59, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fix": `Header_nomad_fix__-T71V`,
	"logo": `Header_nomad_logo__pB3N6`,
	"container": `Header_nomad_container__Y9NNV`,
	"content": `Header_nomad_content__njnpx`,
	"left": `Header_nomad_left__WADgW`,
	"pmPass": `Header_nomad_pmPass__hRltL`,
	"nav": `Header_nomad_nav__4irlq`,
	"selected": `Header_nomad_selected__xv2kP`,
	"right": `Header_nomad_right__zdsVz`,
	"lang": `Header_nomad_lang__rs8fq`,
	"langItem": `Header_nomad_langItem__HImH1`,
	"yellow": `Header_nomad_yellow__Wgh8+`,
	"loginBtn": `Header_nomad_loginBtn__wItrZ`,
	"login": `Header_nomad_login__p1OP1`,
	"btn": `Header_nomad_btn__q3FwJ`,
	"btns": `Header_nomad_btns__oh8N3`,
	"auth": `Header_nomad_auth__gPdfU`,
	"points_row": `Header_nomad_points_row__8BzbQ`,
	"points": `Header_nomad_points__btrYq`,
	"pointsValue": `Header_nomad_pointsValue__HseJg`,
	"line": `Header_nomad_line__K7rKc`,
	"profile": `Header_nomad_profile__zFESE`,
	"profileImg": `Header_nomad_profileImg__i6kIu`,
	"enter": `Header_nomad_enter__hZts7`,
	"hoverY": `Header_nomad_hoverY__A2FzT`,
	"active": `Header_nomad_active__uIYnP`,
	"langDropdown": `Header_nomad_langDropdown__6AMDU`
};
export default ___CSS_LOADER_EXPORT___;
